import { anim, prog } from '../motion'
import { Avatar, Box, Check, Shape } from '../primitives'

// Ein Schritt: beide Seiten treffen sich, die Formen blühen auf
const KINDS = ['tri', 'sq', 'dot']
const TONES = ['blue', 'green', 'yellow', 'pink']
const GOLDEN = 2.39996

const BLOOM = Array.from({ length: 30 }, (_, i) => {
  const angle = i * GOLDEN
  const dist = 190 + ((i * 53) % 170)
  return {
    kind: KINDS[i % 3],
    color: TONES[i % 4],
    x: Math.cos(angle) * dist * 1.35,
    y: Math.sin(angle) * dist * 0.8,
    r: ((i * 47) % 90) - 45,
    size: 14 + ((i * 7) % 16),
    at: [0.3 + (i % 6) * 0.01, 0.46 + (i % 6) * 0.01]
  }
})

export default function SceneHire() {
  return (
    <>
      {BLOOM.map((b, i) => (
        <div
          key={i}
          className='sty-abs'
          style={{ left: 480 + b.x - b.size / 2, top: 330 + b.y - b.size / 2 }}
        >
          <div style={anim({ at: b.at, x: -b.x, y: -b.y, s: 0.1, r: b.r * 3 })}>
            <Shape kind={b.kind} color={b.color} size={b.size} rotate={b.r} />
          </div>
        </div>
      ))}

      <svg
        className='sty-abs sty-overflow'
        width={960}
        height={640}
        style={{ left: 0, top: 0 }}
        aria-hidden='true'
      >
        <line
          x1={330}
          y1={150}
          x2={630}
          y2={150}
          stroke='#B2B4B6'
          strokeWidth={3}
          strokeDasharray='2 10'
          strokeLinecap='round'
          style={{ ...prog([0.2, 0.32]), opacity: 'var(--p)' }}
        />
      </svg>

      <div
        className='sty-abs sty-person'
        style={{
          left: 250,
          top: 70,
          ...anim({ at: [0.02, 0.2], x: -180, y: 0 })
        }}
      >
        <Avatar initials='M' color='blue' size={120} />
        <div className='sty-strong sty-mt-2'>Mara</div>
        <div className='sty-muted sty-small'>Recruiting</div>
      </div>
      <div
        className='sty-abs sty-person'
        style={{
          left: 590,
          top: 70,
          ...anim({ at: [0.02, 0.2], x: 180, y: 0 })
        }}
      >
        <Avatar initials='L' color='pink' size={120} />
        <div className='sty-strong sty-mt-2'>Lena</div>
        <div className='sty-muted sty-small'>Customer Success</div>
      </div>

      <Box
        x={290}
        y={290}
        w={380}
        h={220}
        className='sty-card sty-offer'
        style={anim({ at: [0.26, 0.38], s: 0.85, y: 30 })}
      >
        <div style={anim({ at: [0.36, 0.44], s: 0.2, y: 0 })}>
          <Check size={48} />
        </div>
        <div className='sty-h3 sty-mt-3'>Willkommen im Team, Lena!</div>
        <div className='sty-muted sty-mt-1'>Customer Success Managerin</div>
      </Box>
    </>
  )
}
